import React, {useEffect} from "react";
import leftPng from "../../../../../content/images/left.png";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import NumberFormat from "react-number-format";
import {wait} from "@testing-library/react";
import withImportantStyle from "react-with-important-style";

var MyDiv = withImportantStyle("div");

class OverzichtObject extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableArray: [],
            constTableArray: [],
            uitvoerder: "",
            procentueel: "",
            nieuwbedrag: "",
            vastbedrag: "",
            uitvoerderSelect: [],
            createState: false,
            createButtonState: false,
            editButtonState: false,
            uitvoerderText: "",
            uitvoerderId: "",
            activeIndexId: "",
            activeIndex: false,
            activityIdentification: "",
            hiddenActive: true,
            selectedId: null,
            selectedName: null,
            identifier: null
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
    }


    trCount = 1;

    handleEvent() {
        // this.state = {
        //   tableArray: this.state.tableArray,
        //   uitvoerder: this.state.uitvoerder,
        //   procentueel: this.state.procentueel,
        //   nieuwbedrag: this.state.nieuwbedrag,
        //   uitvoerderSelect: this.state.uitvoerderSelect,
        // };
    }

    /**
     * * girilen değerler anlık olarak çekilir.
     * @param {element hareketlerini getirir.} event
     * @constant {sadece rakam kabul edilir. } const re = /^[0-9\b]+$/;
     */
    handleInputChange = (event) => {
        const re = /^[0-9\b]+$/;
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (
            event.target.value === "" ||
            re.test(event.target.value) ||
            name == "uitvoerder"
        ) {
            this.setState({
                [name]: value,
            });

            if (name == "uitvoerder") {
                var index = event.nativeEvent.target.selectedIndex;
                this.setState({uitvoerderText: event.nativeEvent.target[index].text});
            }
        }
    };

    async handleSubmit() {
        var _continue = true;
        $("#cover-spin").show(0);
        var selectedIds = [];
        $("#example")
            .dataTable()
            .$("tr.selected")
            .each(function () {
                selectedIds.push($(this).attr("rowId"));
            });
        /**
         * * 1. ilk önce tüm verileri sil
         * * 2. sonra tüm verileri kaydet.
         */

        /**
         * * 1.adım
         */
        var model = [];
        var totalBaseCount =
            this.state.constTableArray !== undefined
                ? this.state.constTableArray.length
                : 1;

        if (this.state.constTableArray) {
            await this.state.constTableArray.forEach(async (item, index) => {
                await model.push({
                    op: "remove",
                    path: `/content/algemeen/prijsperuitvoerder/${--totalBaseCount}`,
                });
            });
            if (model.length > 0) {
                let result = await omnimap.PatchMethodAction(
                    model,
                    selectedIds[0],
                    false,
                    window.$mm_management_units_token
                );
                if (result.result.status === "OK") {
                    _continue = true;
                } else {
                    _continue = false;
                    alert("error");
                }
            }
        }

        /**
         * * 2. adım
         */
        var modelCreate = [
            {
                op: "add",
                path: "/content/algemeen/prijsperuitvoerder",
                value: [],
            },
        ];
        await this.state.tableArray.forEach(async (element, index) => {
            await modelCreate[0].value.push({
                uitvoerder: {
                    display: [
                        {
                            path: "$.name",
                            value: element.uitvoerder.display[0].value,
                        },
                    ],
                    identification: element.uitvoerder.identification,
                },
                vastbedrag: Number(element.vastbedrag),
                nieuwbedrag: Number(element.nieuwbedrag),
                procentueel: Number(element.procentueel),
            });
        });
        if (modelCreate.length > 0 && _continue) {
            let result = await omnimap.PatchMethodAction(
                modelCreate,
                selectedIds[0],
                false,
                window.$mm_management_units_token
            );
            if (result.result.status === "OK") {
                _continue = true;
            } else {
                alert("error");
                this.setState({tableArray: this.state.constTableArray});
            }
        }

        $("#cover-spin").hide(0);
    }

    async GetDetail(params) {
        $("#cover-spin").show(0);
        var selectedIds = [];
        $("#example")
            .dataTable()
            .$("tr.selected")
            .each(function () {
                selectedIds.push($(this).attr("rowId"));
            });

        let intersection = window.$mm_management_units_Glist
            .filter((x) => selectedIds.includes(x.identification))
            .map(function (item) {
                return item.algemeenGisratioid;
            });
        const plannigModel = {
            content: [
                {
                    and_or: "AND",
                    datatype: "STRING",
                    key: "algemeen-gisratio",
                    values: [...intersection],
                },
            ],
            definitions: [process.env.REACT_APP_MM_PLANNIG],
            statuses: [
                {status: "akkoord", and_or: "OR"},
                {status: "controle ok", and_or: "OR"},
                {status: "gepland", and_or: "OR"},
                {status: "niet akkoord", and_or: "OR"},
            ],
            context: [],
        };
        //  {
        //   content: [
        //     {
        //       and_or: "AND",
        //       datatype: "STRING",
        //       key: "algemeen-gisratio",
        //       values: [...intersection],
        //     },
        //   ],
        //   definitions: [process.env.REACT_APP_MM_PLANNIG],
        //   sorting: [],
        // };
        let result = await omnimap.FillTableAction(
            plannigModel,
            1,
            window.$mm_management_units_token
        );

        await this.setState({
            tableArray: result.data
                ? result.data
                : [] /*result.data.content.algemeen.prijsperuitvoerder*/,
            constTableArray: result.data,
            hiddenActive: true,
        });

        $("#cover-spin").hide(0);
    }

    addUitTable() {
        this.setState({
            createState: !this.state.createState,
            createButtonState: !this.state.createButtonState,
            procentueel: "",
            nieuwbedrag: "",
            vastbedrag: "",
        });
    }

    backTable() {
        this.setState({
            createState: !this.state.createState,
            createButtonState: false,
            editButtonState: false,
        });
    }

    async addUit() {
        var model = {
            uitvoerder: {
                display: [
                    {
                        path: "$.name",
                        value: this.state.uitvoerderText,
                    },
                ],
                identification: GC.uuidv4(),
            },
            vastbedrag: this.state.vastbedrag,
            nieuwbedrag: this.state.nieuwbedrag,
            procentueel: this.state.procentueel,
            sort: this.state.activeIndex ? this.state.activeIndexId : this.trCount++,
        };

        // Create a new array based on current state:
        let newList = [...this.state.tableArray];

        // Add item to it
        newList.push(model);

        // Set state
        await this.setState({
            tableArray: newList,
            createState: false,
            createButtonState: false,
        });
    }

    editUit(rowId) {
        const stage = this.state.tableArray.filter(
            (row) => row.uitvoerder.identification === rowId
        )[0];
        this.setState({
            uitvoerder: stage.uitvoerder.identification,
            uitvoerderText: stage.uitvoerder.display[0].value,
            procentueel: stage.procentueel,
            nieuwbedrag: stage.nieuwbedrag,
            vastbedrag: stage.vastbedrag,
            createState: true,
            createButtonState: false,
            editButtonState: true,
            activeIndexId: rowId,
        });
    }

    async editUitSave() {
        await this.remove(this.state.activeIndexId);
        await this.setState({activeIndex: true});
        await this.addUit();
        await this.setState({activeIndex: false, editButtonState: false});
    }

    remove(row) {
        this.setState({
            hiddenActive: false,
            selectedId: row.identification,
            selectedName: row.content["algemeen-gisratio"],
            identifier: row.identifier
        });
    }

    delete() {
        $("#cover-spin").show(0);
        omnimap
            .Delete(this.state.selectedId, window.$mm_management_units_token)
            .then((result) => {
                GC.sleep(1500).then(() => this.GetDetail());
            });
    }

    handleToggleClose() {
        this.setState({hiddenActive: true});
    }

    filterList(e) {
        if (e.target.value === "") {
            this.setState({tableArray: this.state.constTableArray});
        } else {
            const arrayCopy = this.state.constTableArray.filter((row) =>
                row.uitvoerder.display[0].value
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            );
            this.setState({tableArray: arrayCopy});
        }
    }

    componentDidMount() {
        var that = this;
        $("#overzicht_object").on("show.bs.modal", function (event) {
            that.GetDetail();
        });
    }

    render() {
        this.handleEvent();
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="overzicht_object"
            >
                <div
                    className="modal-dialog"
                    role="document"
                    style={{maxWidth: "955px"}}
                >
                    <MyDiv
                        className="modal-content"
                        style={{maxWidth: "1050px !important", width: "1500px"}}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Overzicht Object</h5>
                            {this.state.hiddenActive ? (
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                />
                            ) : (
                                true
                            )}
                        </div>
                        <div className="modal-body">
                            <div
                                className="modal-scroll"
                                hidden={this.state.hiddenActive ? false : true}
                            >
                                <table
                                    class="table table-striped"
                                    hidden={this.state.createState ? true : false}
                                >
                                    <thead>
                                    <tr>
                                        <th scope="col">Naam maatregel</th>
                                        <th scope="col">Gisratio Id</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Naam planningspatroon</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.tableArray.map((row) => (
                                        <tr id={row.identification}>
                                            <td>{row.content["maatregel-naam"]}</td>
                                            <td>{row.content["algemeen-gisratio"]}</td>
                                            <td>{row.status[0].status}</td>
                                            <td>{row.content["planningspatroon-naam"]}</td>
                                            <td>
                                                <div class="btn-group" role="group">
                                                    {/* <a
                              id=""
                              class="button-modal-table bewerken"
                              onClick={() => this.editUit(row.identification)}
                            ></a>
                            {"\u00A0"} */}
                                                    <a
                                                        class="button-modal-table delete"
                                                        id=""
                                                        onClick={() => this.remove(row)}
                                                    ></a>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            <div
                                id="delete-side"
                                hidden={this.state.hiddenActive ? true : false}
                            >
                                <div id="delete-side-img"></div>

                                {this.state.hiddenActiveAlert ? (
                                    <div>
                                        <div className="delete-side-div">
                      <span className="delete-side-text">
                        Omdat er mappen aan deze map zijn gekoppeld, kunt u deze
                        niet verwijderen
                      </span>
                                        </div>

                                        <div className="delete-side">
                                            <div className="delete-side-cancel">
                                                <a
                                                    className="button back"
                                                    onClick={() => this.handleToggleClose}
                                                >
                                                    Annuleren
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="delete-side-div">
                      <span className="delete-side-text">
                        Weet u zeker dat u maatregel
                          <span id="delete-folder-name">
                              {" "}“{this.state.identifier}”{" "}
                          </span>
                          bij beheerobject
                          <span id="delete-folder-name">
                              {" "}“{this.state.selectedName}”{" "}
                          </span>
                          wilt verwijderen?
                      </span>
                                        </div>
                                        <div
                                            className="delete-side"
                                            style={{paddingLeft: "196px"}}
                                        >
                                            <div className="delete-side-cancel">
                                                <a
                                                    className="button back"
                                                    onClick={() => this.handleToggleClose()}
                                                >
                                                    Annuleren
                                                </a>
                                            </div>
                                            <div className="delete-side-ok">
                                                <a
                                                    className="button delete"
                                                    onClick={this.delete.bind(this)}
                                                >
                                                    Verwijder{"\u00A0"}map
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer"></div>
                    </MyDiv>
                </div>
            </div>
        );
    }
}

export default OverzichtObject;
